import FileKit from "@convertkit/file-kit"

const createFeed = accountId => {
  const filekit = FileKit({
    authURL: "/filekit/sessions",
    filekitURL: process.env.FILEKIT_HOST,
    id: accountId
  })

  const createProvider = async function({
    name,
    auth_token,
    auth_token_expires_at,
    type
  }) {
    const result = await filekit.createProvider({
      name: name,
      auth_token: auth_token,
      auth_token_expires_at: auth_token_expires_at,
      type: type
    })
    return result
  }

  const createFeed = async function({ name, provider_id }) {
    const result = await filekit.createFeed({
      name: name,
      provider_id: provider_id
    })
    return result
  }

  // Convenience method to create a provider on the fly
  const createFeedAndProvider = async function({
    name,
    provider_name,
    auth_token,
    auth_token_expires_at,
    type,
    properties
  }) {
    const provider = await createProvider({
      name: provider_name,
      auth_token: auth_token,
      auth_token_expires_at: auth_token_expires_at,
      type: type,
      properties: properties
    })
    const feed = await createFeed({
      name: name,
      provider_id: provider.id,
      properties: properties
    })
    return feed
  }

  return createFeedAndProvider
}

export { createFeed }
